// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nbody[data-v-797325e7] {\n  min-width:100% !important;\n  overflow: auto !important;\n}\n@media print{\nhtml[data-v-797325e7], body[data-v-797325e7] {\n    size:210mm 297mm; /*A4*/\n    transform:scale(0.98, 0.98);\n}\n}\n\n", ""]);
// Exports
module.exports = exports;
